import * as React from 'react'
import { API } from '../../services/api'
import { PasskeyCredentialSummary } from '../../models/passkey'

export type PasskeysStatus = 'loading' | 'error' | 'ready'

export const usePasskeys = () => {
  const [status, setStatus] = React.useState<PasskeysStatus>('loading')
  const [credentials, setCredentials] = React.useState<Array<PasskeyCredentialSummary>>([])

  const refetch = React.useCallback(async () => {
    setStatus('loading')
    const response = await API.getInstance().listPasskeys()
    if (response.ok && response.data) {
      setCredentials(response.data.credentials)
      setStatus('ready')
    } else {
      setStatus('error')
    }
  }, [])

  React.useEffect(() => {
    refetch()
  }, [refetch])

  const prepend = React.useCallback(
    (credential: PasskeyCredentialSummary) =>
      setCredentials((prev) => [credential, ...prev]),
    []
  )

  const replace = React.useCallback(
    (credential: PasskeyCredentialSummary) =>
      setCredentials((prev) => prev.map((c) => (c.id === credential.id ? credential : c))),
    []
  )

  const remove = React.useCallback(
    (id: string) => setCredentials((prev) => prev.filter((c) => c.id !== id)),
    []
  )

  return { status, credentials, refetch, prepend, replace, remove }
}
